var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 100.8,
    height: 75.6,
    viewBox: "0 0 100.8 75.6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M91.35 4.2H40.95C38.0505 4.2 35.7 6.5505 35.7 9.45V43.05C35.7 45.9495 38.0505 48.3 40.95 48.3H91.35C94.2495 48.3 96.6 45.9495 96.6 43.05V9.45C96.6 6.5505 94.2495 4.2 91.35 4.2Z",
    fill: "#FFEDD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M92.4 4.2H39.9C37.5804 4.2 35.7 6.0804 35.7 8.4C35.7 10.7196 37.5804 12.6 39.9 12.6H92.4C94.7196 12.6 96.6 10.7196 96.6 8.4C96.6 6.0804 94.7196 4.2 92.4 4.2Z",
    fill: "#FDBA74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M59.85 18.9H45.15C43.4103 18.9 42 20.3103 42 22.05V30.45C42 32.1897 43.4103 33.6 45.15 33.6H59.85C61.5897 33.6 63 32.1897 63 30.45V22.05C63 20.3103 61.5897 18.9 59.85 18.9Z",
    fill: "#FED7AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M88.2 18.9H69.3C68.1402 18.9 67.2 19.8402 67.2 21C67.2 22.1598 68.1402 23.1 69.3 23.1H88.2C89.3598 23.1 90.3 22.1598 90.3 21C90.3 19.8402 89.3598 18.9 88.2 18.9Z",
    fill: "#FDBA74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M81.9 27.3H69.3C68.1402 27.3 67.2 28.2402 67.2 29.4C67.2 30.5598 68.1402 31.5 69.3 31.5H81.9C83.0598 31.5 84 30.5598 84 29.4C84 28.2402 83.0598 27.3 81.9 27.3Z",
    fill: "#FED7AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M71.4 21H18.9C15.4206 21 12.6 23.8206 12.6 27.3V63C12.6 66.4794 15.4206 69.3 18.9 69.3H71.4C74.8794 69.3 77.7 66.4794 77.7 63V27.3C77.7 23.8206 74.8794 21 71.4 21Z",
    fill: "white",
    stroke: "#FED7AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.6 27.3C12.6 25.6291 13.2637 24.0267 14.4452 22.8452C15.6267 21.6637 17.2291 21 18.9 21H71.4C73.0709 21 74.6733 21.6637 75.8548 22.8452C77.0362 24.0267 77.7 25.6291 77.7 27.3V30.45H12.6V27.3Z",
    fill: "#FB923C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.9 27.72C19.7119 27.72 20.37 27.0619 20.37 26.25C20.37 25.4381 19.7119 24.78 18.9 24.78C18.0881 24.78 17.43 25.4381 17.43 26.25C17.43 27.0619 18.0881 27.72 18.9 27.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M24.15 27.72C24.9619 27.72 25.62 27.0619 25.62 26.25C25.62 25.4381 24.9619 24.78 24.15 24.78C23.3381 24.78 22.68 25.4381 22.68 26.25C22.68 27.0619 23.3381 27.72 24.15 27.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M29.4 27.72C30.2119 27.72 30.87 27.0619 30.87 26.25C30.87 25.4381 30.2119 24.78 29.4 24.78C28.5881 24.78 27.93 25.4381 27.93 26.25C27.93 27.0619 28.5881 27.72 29.4 27.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M40.95 36.75H22.05C20.3103 36.75 18.9 38.1603 18.9 39.9V52.5C18.9 54.2397 20.3103 55.65 22.05 55.65H40.95C42.6897 55.65 44.1 54.2397 44.1 52.5V39.9C44.1 38.1603 42.6897 36.75 40.95 36.75Z",
    fill: "#FFEDD5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M69.3 36.75H50.4C49.2402 36.75 48.3 37.6902 48.3 38.85C48.3 40.0098 49.2402 40.95 50.4 40.95H69.3C70.4598 40.95 71.4 40.0098 71.4 38.85C71.4 37.6902 70.4598 36.75 69.3 36.75Z",
    fill: "#FDBA74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M63 45.15H50.4C49.2402 45.15 48.3 46.0902 48.3 47.25C48.3 48.4098 49.2402 49.35 50.4 49.35H63C64.1598 49.35 65.1 48.4098 65.1 47.25C65.1 46.0902 64.1598 45.15 63 45.15Z",
    fill: "#FED7AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M69.3 59.85H21C19.8402 59.85 18.9 60.7902 18.9 61.95C18.9 63.1098 19.8402 64.05 21 64.05H69.3C70.4598 64.05 71.4 63.1098 71.4 61.95C71.4 60.7902 70.4598 59.85 69.3 59.85Z",
    fill: "#FFEDD5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllWeb);
export default __webpack_public_path__ + "static/media/ill-web.d66ee5f7dc18f4804f432afb17ec9449.svg";
export { ForwardRef as ReactComponent };